import { merge } from '../helper';
import isEmptyObject from '../general/isEmpty/isEmptyObject';

import * as exRange from '../forms/range';

import * as exElement from './element';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const elements: Record<string, any> = {};

    // Create element (wrap)
    const elWrap = exElement.create({
        merge: defConfig,
        class: {
            new: 'range-wrap',
        },
    });
    elements.element = elWrap;

    // Create element (range)
    const range = exRange.create({
        merge: defConfig,
        value: 0,
        min: 0,
        max: 100,
        step: 1,
    });
    elements.range = range;

    // ------------------------------------------------------------------------

    // Settings
    settings(elements, defConfig);

    // ------------------------------------------------------------------------

    // Return
    return elements;
}

function settings(elements: Record<string, any>, config: Record<string, any> = {}): void {
    // If using bubble
    if (config.bubble === true || !isEmptyObject(config.bubble)) {
        // Create element (bubble)
        const elBubble = exElement.create({
            merge: config.bubble,
            tag: 'output',
            class: {
                new: 'bubble top',
            },
        });
        elements.element.appendChild(elBubble);
        elements.buddle = elBubble;

        // Create event (input)
        elements.range.addEventListener('input', function (this: any): any {
            setBubble(this, elBubble);
        });
        //
        setBubble(elements.range, elBubble);
    }
}

// ----------------------------------------------------------------------------

function setBubble(range: any, bubble: any): void {
    const val = range.value;
    const min = range.min ? range.min : 0;
    const max = range.max ? range.max : 100;
    const newVal = Number(((val - min) * 100) / (max - min));
    bubble.innerHTML = val;

    // Sorta magic numbers based on size of the native UI thumb
    bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
}
// ----------------------------------------------------------------------------

export { create };
